import React, { useState } from 'react';
import axios from 'axios';
import {
  FormContainer,
  Title,
  Subtitle,
  Label,
  Input,
  FileInput,
  CheckboxLabel,
  SubmitButton,
  NameAndPhoneContainer,
  InputContainer,
  CVContainer,
  ButtonContainer,
  InputCountry
} from './JoinTeam.style';
import { BiFolder } from 'react-icons/bi';

const JoinTeam = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    pais: '',
    acceptTerms: false
  });
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
    } else {
      alert('Por favor seleccione un archivo PDF');
      e.target.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.pais || !formData.acceptTerms) {
      alert('Por favor complete todos los campos requeridos, seleccione un país y acepte los términos');
      return;
    }

    if (!file) {
      alert('Por favor adjunte su CV en formato PDF');
      return;
    }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('pais', formData.pais);
      formDataToSend.append('cv', file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/join-team`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.data.success) {
        alert(response.data.message);
        // Reset form
        setFormData({
          name: '',
          phone: '',
          email: '',
          pais: '',
          acceptTerms: false
        });
        setFile(null);
        // Reset file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Hubo un error al enviar el formulario. Por favor intente nuevamente.');
    }

    setIsSubmitting(false);
  };

  return (
    <FormContainer >
      <Title>Sé parte de la familia EUPHA</Title>
      <Subtitle>¡Te estamos esperando!</Subtitle>
      
      <NameAndPhoneContainer>
        <InputContainer>
          <Label>Nombre*</Label>
          <Input
            type="text"
            name="name"
            placeholder="Nombre"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </InputContainer>

        <InputContainer>
          <Label>Teléfono</Label>
          <Input
            type="tel"
            name="phone"
            placeholder="Teléfono"
            value={formData.phone}
            onChange={handleChange}
          />
        </InputContainer>
      </NameAndPhoneContainer>

      <NameAndPhoneContainer>
        <InputContainer>
          <Label>Correo*</Label>
          <Input
            type="email"
            name="email"
            placeholder="Correo electrónico"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </InputContainer>

        <InputContainer>
          <Label>País*</Label>
          <InputCountry
            as="select"
            name="pais"
            value={formData.pais}
            onChange={handleChange}
            required
          >
            <option value="">Seleccionar país</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Guatemala">Guatemala</option>
          </InputCountry>
        </InputContainer>
      </NameAndPhoneContainer>
      
      <CVContainer>
        <Label>CV* (PDF)</Label>
        <FileInput as="label" htmlFor="cv-upload">
          <BiFolder/>
          <p>{file ? file.name : ' Enviar PDF'}</p>
          <input
            id="cv-upload"
            type="file"
            accept=".pdf"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            required
          />
        </FileInput>
      </CVContainer>

      <CheckboxLabel>
        <input
          type="checkbox"
          name="acceptTerms"
          checked={formData.acceptTerms}
          onChange={handleChange}
          required
        />
        Acepto las condiciones de uso al enviar este formulario.
      </CheckboxLabel>
      
      <ButtonContainer>
        <SubmitButton onClick={handleSubmit} type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Enviando...' : 'Enviar formulario'}
        </SubmitButton>
      </ButtonContainer>
    </FormContainer>
  );
};

export default JoinTeam;
